module.exports = __webpack_public_path__ + "static/media/loading-icon.ddfa3d00.svg";